import { NgTemplateOutlet } from '@angular/common'
import { Component, Input } from '@angular/core'
import { Data } from '@angular/router'
import { RemoteData } from '@ftr/foundation'
import { featureFlag } from '@ftr/ui-feature-flags'
import { AppLayoutComponent } from '../app-layout'
import { AppLayoutLegacyComponent } from '../app-layout-legacy'

@Component({
  selector: 'ftr-app-display',
  templateUrl: './app-display.component.html',
  imports: [AppLayoutComponent, AppLayoutLegacyComponent, NgTemplateOutlet],
})
export class AppDisplayComponent {
  @Input() showNavigationRedesign: boolean
  @Input() logoData: RemoteData<string | undefined> = RemoteData.notAsked()
  @Input() routeData: Data | undefined

  isPublicNavigationEnabled = featureFlag('public-navigation')
}
